import React from 'react'
import {
  canViewFurniture,
  canViewPreorder,
  isPriorityCustomerForEclos,
  getNaturalStoneViewingPermissions,
  canViewNaturalStoneSection,
  getIsDBU,
  isEclosGlobalDistributor,
  isEMEACustomerForEclosGlobal,
} from '../../store/login/reducers'
import { connect } from 'react-redux'
import MenuLinksV2 from '../header/MenuLinksV2'

import {
  canViewCatalog,
  canViewBaths,
  canViewMktools,
  canViewOutlet,
  canViewPromotions,
  getCenterMktool,
  getCenterShowroom,
  getCenterWarehose,
  getDRIUSACenterId,
  getLowesCenterId,
  getMktoolsShippingCenter,
  getSelectedCenter,
  getSelectedCenterPreferences,
  getShippingMethod,
  getShowroomCenterId,
  getWarehoseCenterId,
  hasPromoActivated,
  isNoSilestoneCenter,
  isAustralianCenter,
  isEuropeOrIberia,
  isSelectedCenterAvailableToBuyEclosProducts
} from '../../store/centers/reducers'
import { changeCenter } from '../../store/centers/actions'
import { canViewCutToSize, getIsLogged, getIsMallPilotUser, getUserType, canViewConfigurableBath } from '../../store/login/reducers'
import { getUserLandings } from '../../store/landing/reducers'
import { injectIntl } from 'react-intl'
import { getIsSilestoneBrandVisible, canViewEclosBrandInEurope } from '../../store/ui/reducers'

const mapStateToProps = (state, ownProps) => {
  return {
    canViewCatalog: canViewCatalog(state),
    canViewPromotions: canViewPromotions(state),
    canViewPreorder: canViewPreorder(state),
    canViewFurniture: canViewFurniture(state),
    centerPreferences: getSelectedCenterPreferences(state),
    canViewOutlet: canViewOutlet(state),
    hasPromoActivated: hasPromoActivated(state),
    isLogged: getIsLogged(state),
    shippingMethod: getShippingMethod(state),
    userType: getUserType(state),
    selectedCenter: getSelectedCenter(state),
    centerMktool: getCenterMktool(state),
    centerShowroom: getCenterShowroom(state),
    centerWarehouse: getCenterWarehose(state),
    mktoolShippingCenter: getMktoolsShippingCenter(state),
    canViewBaths: canViewBaths(state),
    userLandings: getUserLandings(state),
    isMallPilotUser: getIsMallPilotUser(state),
    warehoseCenterId: getWarehoseCenterId(),
    showroomCenterId: getShowroomCenterId(),
    DRIUSACenterId: getDRIUSACenterId(),
    lowesCenerId: getLowesCenterId(),
    canViewMktools: canViewMktools(state),
    canViewCutToSize: canViewCutToSize(state),
    customClass: ownProps.customClass ? ownProps.customClass : null,
    header: ownProps.comp,
    isWarehouse: getSelectedCenter(state) == getWarehoseCenterId(),
    isNoSilestoneCenter: isNoSilestoneCenter(state),
    canViewConfigurableBath: canViewConfigurableBath(state),
    isAustralianCenter: isAustralianCenter(state),
    isSilestoneBrandVisible: getIsSilestoneBrandVisible(state),
    isPriorityCustomerForEclos: isPriorityCustomerForEclos(state),
    naturalStoneViewingPermissions: getNaturalStoneViewingPermissions(state),
    canViewNaturalStoneSection: canViewNaturalStoneSection(state),
    isEuropeOrIberia: isEuropeOrIberia(state),
    canViewEclosBrandInEurope: canViewEclosBrandInEurope(state),
    isSelectedCenterAvailableToBuyEclosProducts: isSelectedCenterAvailableToBuyEclosProducts(state),
    isDBU: getIsDBU(state),
    isEclosGlobalDistributor: isEclosGlobalDistributor(state),
    isEMEACustomerForEclosGlobal: isEMEACustomerForEclosGlobal(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeCenter: centerId => {
      dispatch(changeCenter(centerId))
    }
  }
}

const Menu = React.forwardRef((props, ref) =>  {
  return (<MenuLinksV2 ref={ref} {...props} />)
})

const MenuContainer = injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(Menu))

export default  MenuContainer
